module.exports = __webpack_public_path__ + "static/media/prequalLetter.9e92e4ce.svg";